<template>
  <button :class="classes" :disabled="disabled" @click="onClick">
    <i :class="`icon-${icon}`"/>
    <span v-if="label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'Button',
  data () {
    return {
      classes: {
        'button--label': this.label,
        'button--large': this.large,
        'button--primary': this.primary,
        'button--outline': this.outline
      }
    }
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    large: {
      type: Boolean,
      required: false
    },
    primary: {
      type: Boolean,
      required: false
    },
    outline: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    onClick (e) {
      this.audio.play()
      this.$emit('click')
    }
  },
  created () {
    this.audio = new Audio('audio/ui/click.mp3')
  }
}
</script>

<style scoped lang="scss">
button {
  @include clickable();
  position: relative;
  width: $button-md;
  height: $button-md;
  padding: 0.6rem;
  margin-bottom: 0.6rem;
  border: .2rem solid $color-black;
  border-radius: 50%;
  font-size: 3.0rem;
  color: $color-black;
  background: $color-white;
  transition: transform 50ms, opacity 100ms 100ms;
  outline: 0;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  span {
    position: absolute;
    top: $button-md + 0.6rem;
    left: -25%;
    width: 150%;
    font-size: $text-xs;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
  }

  &:active {
    transform: scale(.95);
  }

  &:disabled {
    opacity: 0.3;
    pointer-events: none;
  }
}

.button--label {
  margin-bottom: 3.6rem;

  &.button--large {
    margin-bottom: 3.9rem;
  }
}

.button--large {
  width: $button-lg;
  height: $button-lg;
  margin-bottom: 0.9rem;
  font-size: 4.5rem;

  span {
    top: $button-lg + 0.9rem;
    font-size: $text-sm;
  }
}

.button--primary {
  border-color: $color-orange;
}

.button--outline {
  background: transparent;
}
</style>
